import React from 'react';
import PropTypes from 'prop-types';
import DropdownMenu from 'common/components/dropdown-menu';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import * as ModalType from 'storyboard/constants/modal-type';
import Colors from 'common/constants/colors';
import './index.scss';

export default class StoryboardChapterMenu extends React.Component {
  static propTypes = {
    arrowFill: PropTypes.string,
    chapter: PropTypes.object,
    data: PropTypes.object.isRequired,
    deleteChapterLabel: PropTypes.string,
    editChapterLabel: PropTypes.string,
    enums: PropTypes.object.isRequired,
    openModal: PropTypes.func,
  };

  static defaultProps = {
    arrowFill: Colors.white,
    chapter: {},
    deleteChapterLabel: t('Delete chapter'),
    editChapterLabel: t('Edit chapter settings'),
    openModal: () => {},
  };

  constructor() {
    super();
    this.handleClickDeleteChapter = this.handleClickDeleteChapter.bind(this);
    this.handleClickEditChapter = this.handleClickEditChapter.bind(this);
  }

  getMenuPosition(data, enums) {
    const {theme} = data.configuration;
    const {NavPositionEnum} = enums;
    switch (theme.navPosition) {
      case NavPositionEnum.LEFT.id:
        return 'down-right';
      case NavPositionEnum.RIGHT.id:
        return 'down-left';
      case NavPositionEnum.TOP.id:
        return 'down-right';
      default:
        return 'up-right';
    }
  }

  render() {
    const menuPosition = this.getMenuPosition(
      this.props.data,
      this.props.enums,
    );
    return (
      <div className={'StoryboardChapterMenu'}>
        <DropdownMenu
          arrowStyle={{
            fill: this.props.arrowFill,
            fillOpacity: 0.85,
            strokeWidth: 0,
          }}
          menuPosition={menuPosition}>
          <li>
            <a href={'#'} onClick={this.handleClickEditChapter}>
              <SvgSymbol name={'edit'} />
              {this.props.editChapterLabel}
            </a>
          </li>
          <li>
            <a
              href={`/reports/dashboards/${this.props.chapter.contentId}`}
              rel='noreferrer'
              target={'_blank'}>
              <SvgSymbol name={'export'} />
              {t('Edit chapter content')}
            </a>
          </li>
          <li className={'DropdownMenuItem--separator'}>
            <hr />
          </li>
          <li>
            <a href={'#'} onClick={this.handleClickDeleteChapter}>
              <SvgSymbol name={'delete'} />
              {this.props.deleteChapterLabel}
            </a>
          </li>
        </DropdownMenu>
      </div>
    );
  }

  handleClickDeleteChapter(event) {
    event.preventDefault();
    this.props.openModal(
      ModalType.DELETE_CHAPTER,
      this.props.deleteChapterLabel,
      this.props.chapter,
    );
  }

  handleClickEditChapter(event) {
    event.preventDefault();
    this.props.openModal(
      ModalType.EDIT_CHAPTER,
      this.props.editChapterLabel,
      this.props.chapter,
    );
  }
}
